import numeral from 'numeral';

export const formatNumber = (number: number, numFormat = '0,0'): string =>
  numeral(number).format(numFormat);

export const roundNumber = (number: number): number => Math.round(number * 10) / 10;

export default {};
